import { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Link2, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";

export default function RequestConnection({ onDone }) {
  const [open, setOpen] = useState(false);
  const [orgName, setOrgName] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/connections/request", { buyer_org_name: orgName, message });
      toast.success("Connection request sent — the buyer will review it");
      setOpen(false);
      setOrgName("");
      setMessage("");
      onDone?.();
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button data-testid="request-connection-btn" onClick={() => setOpen(true)} className="mt-5 bg-slate-900 hover:bg-slate-800">
        <Link2 className="mr-1.5 h-4 w-4" /> Add / Request Buyer Connection
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-white">
          <DialogHeader>
            <DialogTitle className="font-heading">Request Buyer Connection</DialogTitle>
            <DialogDescription>Enter the buyer organization's exact registered name. They'll approve the connection before any POs are shared.</DialogDescription>
          </DialogHeader>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label>Buyer Organization Name *</Label>
              <Input data-testid="connection-org-name" required className="mt-1.5" placeholder="e.g. Shakti Precision Industries Pvt Ltd" value={orgName} onChange={(e) => setOrgName(e.target.value)} />
            </div>
            <div>
              <Label>Message (optional)</Label>
              <Textarea data-testid="connection-message" rows={3} className="mt-1.5" placeholder="Introduce your company and capabilities…" value={message} onChange={(e) => setMessage(e.target.value)} />
            </div>
            <DialogFooter>
              <Button type="button" variant="outline" onClick={() => setOpen(false)}>Cancel</Button>
              <Button type="submit" data-testid="connection-submit" disabled={loading} className="bg-slate-900 hover:bg-slate-800">
                {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Send Request
              </Button>
            </DialogFooter>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
}
